import React from 'react';
import styled from 'styled-components';

const AudioButton = styled.div`
  text-align: center;
  // margin-bottom: 15px;
`;
class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { play: false };
    this.selectedId = props.selectedId;
    this.soundId = props.soundId;
    this.url = props.url;
    this.playIcon = props.playIcon;
    this.pauseIcon = props.pauseIcon;
    this.audio = new Audio(this.url);
    this.audio.preload = 'none';
    this.togglePlay = this.togglePlay.bind(this);
  }
  // componentWillReceiveProps(nextProps) {
  //   // You don't have to do this check first, but it can help prevent an unneeded render
  //   if (nextProps.selectedId !== this.selectedId) {
  //     if (nextProps.selectedId != this.soundId) {
  //       this.setState({ play: false });
  //       // this.props.audio.pause();
  //       this.props.pauseAudio(this.props.url,this.props.soundId)
  //     }
  //   }
  // }
  playAudio() {
    console.log('play audio',this.props.url,this.props.soundId)
    this.props.playAudio(this.props.url,this.props.soundId)
    // console.log('play audio triggered',this.props.audio)
    // const { handleStateChange } = this.props;
    // this.props.audio.play();
    // if (handleStateChange) {
      //   handleStateChange('selectedId', this.soundId);
      //   handleStateChange('currentSoundUrl', this.soundId);
      // }
    }
    pauseAudio(){
    console.log('pause audio',this.props.url,this.props.soundId)
    this.props.pauseAudio(this.props.url,this.props.soundId)
    // const { handleStateChange } = this.props;
    // this.props.audio.pause();
    // if (handleStateChange) {
    //   handleStateChange('selectedId', '');
    //   handleStateChange('currentSoundUrl', '');
    // }
    // console.log('pause audio triggered',this.props.audio,this.props.audio.paused)
  }
  togglePlay() {
    this.setState({ play: !this.state.play }, () => {
      this.state.play ? this.playAudio() : this.pauseAudio();
    });
  }

  componentWillUnmount() {
    // this.audio.pause();
    this.pauseAudio()
  }

  render() {
    return (
      <AudioButton>
        {/* {this.state.play ? (
          <span
            style={{ cursor: 'pointer' }}
            aria-label="Pause"
            onClick={this.togglePlay}
          >
            {this.pauseIcon}
          </span>
        ) : (
          <span
            style={{ cursor: 'pointer' }}
            aria-label="Play"
            onClick={this.togglePlay}
          >
            {this.playIcon}
          </span>
        )} */}
        {this.props.currentSoundUrl === this.soundId?(
          <span
          style={{ cursor: 'pointer' }}
          aria-label="Pause"
          onClick={this.pauseAudio.bind(this)}
        >
          {this.pauseIcon}
        </span>
        ) : (
          <span
            style={{ cursor: 'pointer' }}
            aria-label="Play"
            onClick={this.playAudio.bind(this)}
          >
            {this.playIcon}
          </span>
        )
      }
      </AudioButton>
    );
  }
}

export default AudioPlayer;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AudioPlayer.js